var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2DIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 29.6,
    rx: 4.5,
    fill: "white",
    stroke: "#006AB3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8934 5.92865C18.8934 7.54613 17.5823 8.85731 15.9648 8.85731C14.3473 8.85731 13.0361 7.54613 13.0361 5.92865C13.0361 4.31118 14.3473 3 15.9648 3C17.5823 3 18.8934 4.31118 18.8934 5.92865Z",
    stroke: "#006AB3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9641 10.3242V20.2466",
    stroke: "#006AB3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.679 21.4297L20.0362 26.5727",
    stroke: "#006AB3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1434 21.3574L11.7861 26.5004",
    stroke: "#006AB3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3572 10.9297L11 16.0727",
    stroke: "#006AB3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6428 10.5L21.0001 15.643",
    stroke: "#006AB3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2DIconNew);
export default __webpack_public_path__ + "static/media/2d_icon_new.a2025f91a7708241395702d03ffc8e30.svg";
export { ForwardRef as ReactComponent };